<div class="prescription-banner" *ngIf="selectedDrugs.length && !isHomePage">
  <div class="container">
    <div class="prescription-info">
      <span class="prescription-count">{{ selectedDrugs.length }} prescription(s) added</span>
      <button class="view-prescriptions-btn" (click)="goToPrescriptions()">View Prescriptions</button>
    </div>
  </div>
</div>
